<template>
  <div class="im-text-message" :class="{ in: !isMe, out: isMe }" @longpress="onlongpress">
    <div v-for="(item, index) in messageVal" :key="index" class="text-box">
      <span v-if="item.name === 'text'" :selectable="false" :user-select="false">
        {{ item.text }}
      </span>
      <img
        v-if="item.name === 'img'"
        :show-menu-by-longpress="true"
        class="emoji-icon"
        :src="item.src"
      />
    </div>
  </div>
</template>

<script>
import { emojiMap, emojiName, emojiUrl } from '@/timpackage/utils/emojiMap'
import { decodeText } from '@/timpackage/utils/decodeText'
import { getElementBoundingClientReact } from '@/timpackage/utils/timInit'
export default {
  name: 'imTextMessage',
  props: {
    message: {
      type: Object,
      default() {
        return {}
      }
    },
    showAvatar: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      emojiMap,
      emojiName,
      emojiUrl
    }
  },
  computed: {
    isMe() {
      return this.message.flow === 'out'
    },
    messageVal() {
      return decodeText(this.message.payload)
    }
  },
  methods: {
    async onlongpress() {
      const info = await getElementBoundingClientReact('.im-text-message', this)
      this.$emit('menu', {
        info,
        message: this.message
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.im-text-message {
  display: inline-block;
  vertical-align: top;
  padding: 0.512rem 0.597333rem;
  font-size: 0.64rem;
  line-height: 0.853333rem;
  font-weight: 400;
  white-space: pre-wrap;
  word-break: break-all;
  background: #d4ebff;
  box-shadow: 0rem 0.128rem 0.426667rem 0rem #ebeff9;

  &.in {
    border-radius: 0 0.597333rem 0.597333rem 0.597333rem;
  }

  &.out {
    border-radius: 0.597333rem 0 0.597333rem 0.597333rem;
    .text-box {
      text-align: left;
    }
  }

  .text-box {
    display: inline-block;
    vertical-align: top;
  }
  .emoji-icon {
    display: inline-block;
    vertical-align: top;
    width: 0.853333rem;
    height: 0.853333rem;
  }
}
</style>
